export default __webpack_public_path__ + "static/media/shape_3.77b89ad1.svg";